import {DocumentControllerApiAxiosParamCreator} from './gen';
import {FeatureDetailVO, FeatureImageVO} from './gen/model';

///////////////////////////////////////////////////////////////////////////////////////////////////////
let downloadDokumentUrl;
DocumentControllerApiAxiosParamCreator()
    .getDocument(-999, -666)
    .then(({url}) => {
        downloadDokumentUrl = url;
    });

export const downloadDocument = (idData: string, idDokument: number): string => {
    return downloadDokumentUrl.replace('-999', encodeURIComponent(idData)).replace('-666', encodeURIComponent(idDokument));
};
///////////////////////////////////////////////////////////////////////////////////////////////////////
let downloadTemporaryFilePreviewUrl;
DocumentControllerApiAxiosParamCreator()
    .getTemporaryFile('XXX')
    .then(({url}) => {
        downloadTemporaryFilePreviewUrl = url;
    });

export const downloadTemporaryFilePreview = (idTempFile: string): string => {
    return downloadTemporaryFilePreviewUrl.replace('XXX', encodeURIComponent(idTempFile));
};
///////////////////////////////////////////////////////////////////////////////////////////////////////
/** URL fotografie objektu v plné velikosti – z externího zdroje, jinak jako příloha ze serveru. */
export const getFeatureImageUrl = (item: FeatureDetailVO, imageId: number, serverContextPath: string): string => {
    const image = item.images?.find((img: FeatureImageVO): boolean => img.id === imageId);
    if (image?.url) {
        return image.url;
    }
    return `${serverContextPath}${downloadDocument(item.featureId, imageId)}`;
};
